<h2 mat-dialog-title>{{ dialogTitleKey | translate }}</h2>
<mat-dialog-content>
  <p>{{ dialogDescriptionKey | translate }}</p>
  <div class="form-container">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'TEMPLATES.EDITOR.EDIT_ITEM_DIALOG.ITEM_TITLE' | translate }}</mat-label>
      <input
        matInput
        [(ngModel)]="title"
        [placeholder]="'TEMPLATES.EDITOR.EDIT_ITEM_DIALOG.ITEM_TITLE_PLACEHOLDER' | translate"
        (keydown)="onKeydown($event)"
        cdkFocusInitial
        required
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'TEMPLATES.EDITOR.EDIT_ITEM_DIALOG.DURATION' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="duration" min="0" (keydown)="onKeydown($event)" />
    </mat-form-field>

    <div class="presenters-section">
      <label class="section-label">{{ 'TEMPLATES.EDITOR.EDIT_ITEM_DIALOG.PRESENTERS' | translate }}</label>

      @if (presenters.length > 0) {
      <mat-chip-set class="presenters-chips">
        @for (presenter of presenters; track presenter) {
        <mat-chip [removable]="true" (removed)="removePresenter(presenter)">
          {{ presenter }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
        }
      </mat-chip-set>
      }

      <div class="add-presenter-row">
        <mat-form-field appearance="outline" class="presenter-input">
          <mat-label>{{ 'TEMPLATES.EDITOR.EDIT_ITEM_DIALOG.ADD_PRESENTER' | translate }}</mat-label>
          <input
            matInput
            [(ngModel)]="newPresenterName"
            [placeholder]="'TEMPLATES.EDITOR.EDIT_ITEM_DIALOG.PRESENTER_PLACEHOLDER' | translate"
            [matAutocomplete]="presenterAutocomplete"
            (focus)="filterAttendeeNames()"
            (input)="filterAttendeeNames()"
            (keyup.enter)="addPresenter()"
          />
          <mat-autocomplete
            #presenterAutocomplete="matAutocomplete"
            class="mask-attendee-names"
            (optionSelected)="newPresenterName = $event.option.value; addPresenter()"
          >
            @for (attendeeName of filteredAttendeeNames; track attendeeName) {
            <mat-option [value]="attendeeName"> {{ attendeeName }} </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <button mat-button color="primary" (click)="addPresenter()" [disabled]="newPresenterName.trim() === ''">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="isSaveDisabled">{{ 'COMMON.SAVE' | translate }}</button>
</mat-dialog-actions>
